import { ModelApiService } from './BaseApiService'

export default class MeApiService extends ModelApiService {
  constructor() {
    super('Me')
  }

  async getUserRoles() {
    return this.get('aspnetroles')
  }
}
